import { p as proxyCustomElement, H, h, a as Host, F as Fragment } from './index.js';
import { d as defineCustomElement$9 } from './p-BbTg3Car.js';
import { d as defineCustomElement$8 } from './p-z4UJ58j1.js';
import { d as defineCustomElement$7 } from './p-C9_XXP_a.js';
import { d as defineCustomElement$6 } from './p-Da2lAZSv.js';
import { d as defineCustomElement$5 } from './p-BDGM1f6L.js';
import { d as defineCustomElement$4 } from './p-BtEI0Sh2.js';
import { d as defineCustomElement$3 } from './p-CFAyJ2yW.js';
import { d as defineCustomElement$2 } from './p-ClSUnmWE.js';

const componentFooterCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host(.label-values){display:flex;gap:1rem;padding:1rem}.label{color:var(--jw-theme-surface-text-description-color);font-weight:400}.label,.value{font-family:Open Sans;font-size:.875rem;letter-spacing:-.0004em;line-height:1.25rem}.value{color:var(--jw-theme-surface-text-default-color);font-weight:600}";

const WuiComponentFooter$1 = /*@__PURE__*/ proxyCustomElement(class WuiComponentFooter extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    render() {
        const firstComponent = this.contents?.[0].component;
        switch (firstComponent) {
            case 'label':
                return (h(Host, { class: "label-values", type: "label" }, this.contents?.map(({ component, props }, idx, arr) => {
                    if (component !== 'label') {
                        return null;
                    }
                    return (h(Fragment, null, h("div", null, h("span", { class: "label" }, props.label), ": ", h("span", { class: "value" }, props.value)), Boolean(idx !== arr.length - 1) && h("wui-divider", { type: "vertical" })));
                })));
            case 'button': {
                const deleteButton = this.contents?.find(({ props }) => 'type' in props && props.type === 'delete');
                return (h(Host, { type: "button" }, h("wui-box", { orientation: "horizontal", justify: "space-between" }, deleteButton ? (h("wui-button", { ...deleteButton.props, label: "Delete", icon: "trash", type: "tertiary", intent: "error" })) : (h("div", null)), h("wui-layout", { type: "button-group" }, this.contents?.map(({ component, props }) => {
                    if (component !== 'button' || props.type === 'delete') {
                        return null;
                    }
                    return h("wui-button", { ...props });
                })))));
            }
        }
    }
    static get style() { return componentFooterCss; }
}, [257, "wui-component-footer", {
        "contents": [16]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-component-footer", "wui-box", "wui-button", "wui-divider", "wui-icon", "wui-layout", "wui-loader", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-component-footer":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiComponentFooter$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-layout":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiComponentFooter = WuiComponentFooter$1;
const defineCustomElement = defineCustomElement$1;

export { WuiComponentFooter, defineCustomElement };
